import { Badge } from '@/components/ui/badge.jsx';

// Maps the pipeline's derived UI stage to a human-readable label + a
// badge variant from the spec §3 token set.
//
// V1 covers the stages actually rendered (i.e. STAGE_TO_CATEGORY keys
// that aren't null — backend already filters terminal/hold from the
// command-center response).

const STAGE_LABEL = {
  // Derived lifecycle states (DEAL-LIFECYCLE-SPEC Phase 1, lowercase keys
  // from services/deal-state.service.js computeDealState).
  prospect: 'Prospect',
  shopping: 'Shopping',
  presented: 'Presented',
  binding: 'Binding',
  bound: 'Bound',
  placed: 'Placed',
  distributed: 'Distributed',
  lost: 'Lost',
  cancelled: 'Cancelled',
  expired: 'Expired',
  UPCOMING: 'Upcoming',
  NEW_BUSINESS: 'New business',
  INITIATED: 'Initiated',
  COLLECTING: 'Collecting',
  READY_TO_QUOTE: 'Ready to quote',
  QUOTING: 'Quoting',
  PRESENTED: 'Presented',
  BINDING: 'Binding',
  PAID: 'Paid',
  BOUND: 'Bound',
  RENEWAL_DUE: 'Renewal due',
  EXPIRED: 'Expired',
  ON_HOLD: 'On hold',
  LOST: 'Lost',
  CANCELLED: 'Cancelled',
};

const STAGE_VARIANT = {
  prospect: 'outline',
  shopping: 'info',
  presented: 'warning',
  binding: 'warning',
  bound: 'success',
  placed: 'success',
  distributed: 'success',
  lost: 'muted',
  cancelled: 'muted',
  expired: 'muted',
  UPCOMING: 'outline',
  NEW_BUSINESS: 'info',
  INITIATED: 'outline',
  COLLECTING: 'outline',
  READY_TO_QUOTE: 'info',
  QUOTING: 'info',
  PRESENTED: 'warning',
  BINDING: 'warning',
  PAID: 'success',
  BOUND: 'success',
  RENEWAL_DUE: 'accent',
  EXPIRED: 'muted',
  // `ON_HOLD` IS NOT `muted`. The other four in this cluster are terminal:
  // EXPIRED, LOST, CANCELLED are over, and the strikethrough says so. A HOLD is
  // a LIVE deal that is paused: tracon.routes derives it from `state.hold` and
  // offers `unhold` as its action, so it is the one stage here you can come
  // back from. It was rendering struck through beside the dead ones.
  ON_HOLD: 'outline',
  LOST: 'muted',
  CANCELLED: 'muted',
};

export default function StageBadge({ stage, className }) {
  if (!stage) return null;
  return (
    <Badge variant={STAGE_VARIANT[stage] || 'default'} className={className}>
      {STAGE_LABEL[stage] || stage}
    </Badge>
  );
}
